import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async thunk for updating member information
export const updateMember = createAsyncThunk(
  "member/updateMember",
  async (memberData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "https://onboard.rechargkit.biz/member/updateMember",
        memberData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      // Return a rejected value for error handling
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);

// Initial state for the member slice
const initialState = {
  loading: false,
  success: false,
  error: null,
};

// Create the member slice
const memberSlice = createSlice({
  name: "member",
  initialState,
  reducers: {
    // You can add synchronous actions here if needed
    resetMemberState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateMember.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(updateMember.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      .addCase(updateMember.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload || "Failed to update member";
      });
  },
});

export const { resetMemberState } = memberSlice.actions;
export default memberSlice.reducer;
